import { ProductModelType } from "@ltypes/product";

export const timezones = [
    // {
    //     label: '(GMT-12:00) International Date Line West',
    //     value: 0,
    // },
    // {
    //     label: '(GMT-11:00) Coordinated Universal Time-11',
    //     value: 1,
    // },
    {
        label: '(GMT-11:00) Midway',
        value: 2,
    },
    {
        label: '(GMT-11:00) Niue',
        value: 3,
    },
    {
        label: '(GMT-11:00) Pago_Pago',
        value: 4,
    },
    // {
    //     label: '(GMT-11:00) Samoa',
    //     value: 5,
    // },
    {
        label: '(GMT-10:00) Adak',
        value: 6,
    },
    {
        label: '(GMT-10:00) Rarotonga',
        value: 7,
    },
    {
        label: '(GMT-10:00) Tahiti',
        value: 8,
    },
    {
        label: '(GMT-10:00) Hawaii',
        value: 9,
    },
    {
        label: '(GMT-09:30) Marquesas Islands',
        value: 10,
    },
    {
        label: '(GMT-09:00) Alaska',
        value: 11,
    },
    {
        label: '(GMT-09:00) Gambier',
        value: 12,
    },
    {
        label: '(GMT-08:00) Juneau',
        value: 13,
    },
    {
        label: '(GMT-08:00) Nome',
        value: 14,
    },
    {
        label: '(GMT-08:00) Metlakatla',
        value: 15,
    },
    {
        label: '(GMT-08:00) Sitka',
        value: 16,
    },
    {
        label: '(GMT-08:00) Yakutat',
        value: 17,
    },
    {
        label: '(GMT-08:00) Baja California',
        value: 18,
    },
    {
        label: '(GMT-08:00) Pacific Time (US & Canada)',
        value: 19,
    },
    {
        label: '(GMT-08:00) Pitcairn',
        value: 20,
    },
    {
        label: '(GMT-07:00) Creston',
        value: 21,
    },
    {
        label: '(GMT-07:00) Chihuahua, Mazatlan',
        value: 22,
    },
    {
        label: '(GMT-07:00) Dawson',
        value: 23,
    },
    {
        label: '(GMT-07:00) Dawson Creek',
        value: 24,
    },
    {
        label: '(GMT-07:00) Mountain Time (US & Canada)',
        value: 25,
    },
    // {
    //     label: '(GMT-07:00) Ensenada',
    //     value: 26,
    // },
    {
        label: '(GMT-07:00) Fort Nelson',
        value: 27,
    },
    {
        label: '(GMT-07:00) Hermosillo',
        value: 28,
    },
    {
        label: '(GMT-07:00) Vancouver',
        value: 29,
    },
    {
        label: '(GMT-07:00) Whitehorse',
        value: 30,
    },
    {
        label: '(GMT-07:00) Arizona',
        value: 31,
    },
    {
        label: '(GMT-06:00) Bahia Banderas',
        value: 32,
    },
    {
        label: '(GMT-06:00) Belize',
        value: 33,
    },
    {
        label: '(GMT-06:00) Boise',
        value: 34,
    },
    {
        label: '(GMT-06:00) Costa Rica',
        value: 35,
    },
    {
        label: '(GMT-06:00) Central Time (US & Canada)',
        value: 36,
    },
    {
        label: '(GMT-06:00) Edmonton',
        value: 37,
    },
    {
        label: '(GMT-06:00) El Salvador',
        value: 38,
    },
    {
        label: '(GMT-06:00) Central America',
        value: 39,
    },
    {
        label: '(GMT-06:00) Managua',
        value: 40,
    },
    {
        label: '(GMT-06:00) Mazatlan',
        value: 41,
    },
    {
        label: '(GMT-06:00) Ojinaga',
        value: 42,
    },
    {
        label: '(GMT-06:00) Swift Current',
        value: 43,
    },
    {
        label: '(GMT-06:00) Tegucigalpa',
        value: 44,
    },
    {
        label: '(GMT-06:00) Guadalajara, Mexico City, Monterrey',
        value: 45,
    },
    {
        label: '(GMT-06:00) Saskatchewan',
        value: 46,
    },
    {
        label: '(GMT-06:00) Galapagos',
        value: 47,
    },
    {
        label: '(GMT-05:00) Atikokan',
        value: 48,
    },
    {
        label: '(GMT-05:00) Bogota, Lima, Quito',
        value: 49,
    },
    {
        label: '(GMT-05:00) Cancun',
        value: 50,
    },
    {
        label: '(GMT-05:00) Cayman',
        value: 51,
    },
    // {
    //     label: '(GMT-05:00) Coral Harbour',
    //     value: 52,
    // },
    {
        label: '(GMT-05:00) Eirunepe',
        value: 53,
    },
    {
        label: '(GMT-05:00) Guayaquil',
        value: 54,
    },
    {
        label: '(GMT-05:00) Indiana (East)',
        value: 55,
    },
    {
        label: '(GMT-05:00) Jamaica',
        value: 56,
    },
    {
        label: '(GMT-05:00) Lima',
        value: 57,
    },
    {
        label: '(GMT-05:00) Matamoros',
        value: 58,
    },
    {
        label: '(GMT-05:00) Menominee',
        value: 59,
    },
    {
        label: '(GMT-05:00) Merida',
        value: 60,
    },
    {
        label: '(GMT-05:00) Monterrey',
        value: 61,
    },
    {
        label: '(GMT-05:00) Nipigon',
        value: 62,
    },
    {
        label: '(GMT-05:00) Panama',
        value: 63,
    },
    {
        label: '(GMT-05:00) Rainy River',
        value: 64,
    },
    {
        label: '(GMT-05:00) Rio Branco',
        value: 65,
    },
    {
        label: '(GMT-05:00) Thunder Bay',
        value: 66,
    },
    {
        label: '(GMT-05:00) Winnipeg',
        value: 67,
    },
    {
        label: '(GMT-05:00) Eastern Time (US & Canada)',
        value: 68,
    },
    // {
    //     label: '(GMT-05:00) Easter',
    //     value: 69,
    // },
    {
        label: '(GMT-04:30) Caracas',
        value: 70,
    },
    {
        label: '(GMT-04:00) Anguilla',
        value: 71,
    },
    {
        label: '(GMT-04:00) Antigua',
        value: 72,
    },
    {
        label: '(GMT-04:00) Aruba',
        value: 73,
    },
    {
        label: '(GMT-04:00) Asuncion',
        value: 74,
    },
    {
        label: '(GMT-04:00) Barbados',
        value: 75,
    },
    {
        label: '(GMT-04:00) Boa Vista',
        value: 76,
    },
    {
        label: '(GMT-04:00) Campo Grande',
        value: 77,
    },
    {
        label: '(GMT-04:00) Curacao',
        value: 78,
    },
    {
        label: '(GMT-04:00) Cuiaba',
        value: 79,
    },
    {
        label: '(GMT-04:00) Detroit',
        value: 80,
    },
    {
        label: '(GMT-04:00) Dominica',
        value: 81,
    },
    {
        label: '(GMT-04:00) Grand Turk',
        value: 82,
    },
    {
        label: '(GMT-04:00) Grenada',
        value: 83,
    },
    {
        label: '(GMT-04:00) Guadeloupe',
        value: 84,
    },
    {
        label: '(GMT-04:00) Guyana',
        value: 85,
    },
    {
        label: '(GMT-04:00) Atlantic Time (Canada)',
        value: 86,
    },
    {
        label: '(GMT-04:00) Havana',
        value: 87,
    },
    {
        label: '(GMT-04:00) Georgetown, La Paz, Manaus, San Juan',
        value: 88,
    },
    {
        label: '(GMT-04:00) Manaus',
        value: 89,
    },
    {
        label: '(GMT-04:00) Martinique',
        value: 90,
    },
    // {
    //     label: '(GMT-04:00) Montreal',
    //     value: 91,
    // },
    {
        label: '(GMT-04:00) Montserrat',
        value: 92,
    },
    {
        label: '(GMT-04:00) Nassau',
        value: 93,
    },
    {
        label: '(GMT-04:00) Port of Spain',
        value: 94,
    },
    {
        label: '(GMT-04:00) Porto Velho',
        value: 95,
    },
    {
        label: '(GMT-04:00) Puerto Rico',
        value: 96,
    },
    {
        label: '(GMT-04:00) Santo Domingo',
        value: 97,
    },
    {
        label: '(GMT-04:00) St. Kitts',
        value: 98,
    },
    {
        label: '(GMT-04:00) St. Lucia',
        value: 99,
    },
    {
        label: '(GMT-04:00) St. Thomas',
        value: 100,
    },
    {
        label: '(GMT-04:00) St. Vincent',
        value: 101,
    },
    {
        label: '(GMT-04:00) Toronto',
        value: 102,
    },
    {
        label: '(GMT-04:00) Tortola',
        value: 103,
    },
    // {
    //     label: '(GMT-04:00) Santiago',
    //     value: 104,
    // },
    {
        label: '(GMT-03:30) Newfoundland',
        value: 105,
    },
    {
        label: '(GMT-03:00) Araguaina',
        value: 106,
    },
    {
        label: '(GMT-03:00) Bahia',
        value: 107,
    },
    {
        label: '(GMT-03:00) Belem',
        value: 108,
    },
    {
        label: '(GMT-03:00) Buenos Aires',
        value: 109,
    },
    {
        label: '(GMT-03:00) Cayenne, Fortaleza',
        value: 110,
    },
    {
        label: '(GMT-03:00) Fortaleza',
        value: 111,
    },
    {
        label: '(GMT-03:00) Glace Bay',
        value: 112,
    },
    {
        label: '(GMT-03:00) Goose Bay',
        value: 113,
    },
    // {
    //     label: '(GMT-03:00) Greenland',
    //     value: 114,
    // },
    {
        label: '(GMT-03:00) Maceio',
        value: 115,
    },
    {
        label: '(GMT-03:00) Moncton',
        value: 116,
    },
    {
        label: '(GMT-03:00) Paramaribo',
        value: 117,
    },
    {
        label: '(GMT-03:00) Punta Arenas',
        value: 118,
    },
    {
        label: '(GMT-03:00) Recife',
        value: 119,
    },
    // {
    //     label: '(GMT-03:00) Rosario',
    //     value: 120,
    // },
    {
        label: '(GMT-03:00) Santarem',
        value: 121,
    },
    {
        label: '(GMT-03:00) Thule',
        value: 122,
    },
    {
        label: '(GMT-03:00) Montevideo',
        value: 123,
    },
    {
        label: '(GMT-03:00) Brasilia',
        value: 124,
    },
    {
        label: '(GMT-03:00) Rothera',
        value: 125,
    },
    {
        label: '(GMT-03:00) Bermuda',
        value: 126,
    },
    {
        label: '(GMT-03:00) Stanley',
        value: 127,
    },
    {
        label: '(GMT-02:00) Miquelon',
        value: 128,
    },
    {
        label: '(GMT-02:00) Noronha',
        value: 129,
    },
    {
        label: '(GMT-02:00) South Georgia',
        value: 130,
    },
    // {
    //     label: '(GMT-02:00) Coordinated Universal Time-02',
    //     value: 131,
    // },
    {
        label: '(GMT-01:00) Azores',
        value: 132,
    },
    {
        label: '(GMT-01:00) Cape Verde',
        value: 133,
    },
    {
        label: '(GMT+00:00) UTC',
        value: 134,
    },
    {
        label: '(GMT+00:00) Danmarkshavn',
        value: 135,
    },
    {
        label: '(GMT+00:00) Scoresbysund',
        value: 136,
    },
    {
        label: '(GMT+00:00) Accra',
        value: 137,
    },
    {
        label: '(GMT+00:00) Abidjan',
        value: 138,
    },
    {
        label: '(GMT+00:00) Bamako',
        value: 139,
    },
    {
        label: '(GMT+00:00) Banjul',
        value: 140,
    },
    {
        label: '(GMT+00:00) Bissau',
        value: 141,
    },
    {
        label: '(GMT+00:00) Conakry',
        value: 142,
    },
    {
        label: '(GMT+00:00) Dakar',
        value: 143,
    },
    {
        label: '(GMT+00:00) El Aaiun',
        value: 144,
    },
    {
        label: '(GMT+00:00) Freetown',
        value: 145,
    },
    {
        label: '(GMT+00:00) Lome',
        value: 146,
    },
    {
        label: '(GMT+00:00) Monrovia',
        value: 147,
    },
    {
        label: '(GMT+00:00) Nouakchott',
        value: 148,
    },
    {
        label: '(GMT+00:00) Ouagadougou',
        value: 149,
    },
    {
        label: '(GMT+00:00) Sao Tome',
        value: 150,
    },
    {
        label: '(GMT+00:00) Timbuktu',
        value: 151,
    },
    {
        label: '(GMT+00:00) Troll',
        value: 152,
    },
    {
        label: '(GMT+00:00) St. Helena',
        value: 153,
    },
    {
        label: '(GMT+00:00) Monrovia, Reykjavik',
        value: 154,
    },
    {
        label: '(GMT+00:00) Greenwich Mean Time, Dublin, Edinburgh, Lisbon, London',
        value: 155,
    },
    {
        label: '(GMT+01:00) Bangui',
        value: 156,
    },
    {
        label: '(GMT+01:00) Casablanca',
        value: 157,
    },
    {
        label: '(GMT+01:00) Algiers',
        value: 158,
    },
    {
        label: '(GMT+01:00) Brazzaville',
        value: 159,
    },
    {
        label: '(GMT+01:00) Douala',
        value: 160,
    },
    {
        label: '(GMT+01:00) Kinshasa',
        value: 161,
    },
    {
        label: '(GMT+01:00) Libreville',
        value: 162,
    },
    {
        label: '(GMT+01:00) Luanda',
        value: 163,
    },
    {
        label: '(GMT+01:00) Malabo',
        value: 164,
    },
    {
        label: '(GMT+01:00) Ndjamena',
        value: 165,
    },
    {
        label: '(GMT+01:00) Niamey',
        value: 166,
    },
    {
        label: '(GMT+01:00) Tunis',
        value: 167,
    },
    {
        label: '(GMT+01:00) West Central Africa',
        value: 168,
    },
    {
        label: '(GMT+01:00) Canary',
        value: 169,
    },
    {
        label: '(GMT+01:00) Faroe',
        value: 170,
    },
    {
        label: '(GMT+01:00) Madeira',
        value: 171,
    },
    // {
    //     label: '(GMT+01:00) Belfast',
    //     value: 172,
    // },
    {
        label: '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
        value: 173,
    },
    {
        label: '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
        value: 174,
    },
    {
        label: '(GMT+01:00) Dublin',
        value: 175,
    },
    {
        label: '(GMT+01:00) Guernsey',
        value: 176,
    },
    {
        label: '(GMT+01:00) Isle of Man',
        value: 177,
    },
    {
        label: '(GMT+01:00) Jersey',
        value: 178,
    },
    {
        label: '(GMT+01:00) Lisbon',
        value: 179,
    },
    {
        label: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris',
        value: 180,
    },
    {
        label: '(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
        value: 181,
    },
    {
        label: '(GMT+02:00) Blantyre',
        value: 182,
    },
    {
        label: '(GMT+02:00) Bujumbura',
        value: 183,
    },
    {
        label: '(GMT+02:00) Cairo',
        value: 184,
    },
    {
        label: '(GMT+02:00) Ceuta',
        value: 185,
    },
    {
        label: '(GMT+02:00) Johannesburg',
        value: 186,
    },
    {
        label: '(GMT+02:00) Gaborone',
        value: 187,
    },
    {
        label: '(GMT+02:00) Harare',
        value: 188,
    },
    {
        label: '(GMT+02:00) Khartoum',
        value: 189,
    },
    {
        label: '(GMT+02:00) Kigali',
        value: 190,
    },
    {
        label: '(GMT+02:00) Lubumbashi',
        value: 191,
    },
    {
        label: '(GMT+02:00) Lusaka',
        value: 192,
    },
    {
        label: '(GMT+02:00) Maputo',
        value: 193,
    },
    {
        label: '(GMT+02:00) Maseru',
        value: 194,
    },
    {
        label: '(GMT+02:00) Mbabane',
        value: 195,
    },
    {
        label: '(GMT+02:00) Tripoli',
        value: 196,
    },
    {
        label: '(GMT+02:00) Windhoek',
        value: 197,
    },
    {
        label: '(GMT+02:00) Amman',
        value: 198,
    },
    {
        label: '(GMT+02:00) Beirut',
        value: 199,
    },
    {
        label: '(GMT+02:00) Damascus',
        value: 200,
    },
    // {
    //     label: '(GMT+02:00) Jerusalem',
    //     value: 201,
    // },
    {
        label: '(GMT+02:00) Amsterdam',
        value: 202,
    },
    {
        label: '(GMT+02:00) Andorra',
        value: 203,
    },
    {
        label: '(GMT+02:00) Belgrade',
        value: 204,
    },
    {
        label: '(GMT+02:00) Brussels',
        value: 205,
    },
    {
        label: '(GMT+02:00) Copenhagen',
        value: 206,
    },
    {
        label: '(GMT+02:00) Gibraltar',
        value: 207,
    },
    {
        label: '(GMT+02:00) Athens, Bucharest, Istanbul',
        value: 208,
    },
    {
        label: '(GMT+02:00) Kaliningrad',
        value: 209,
    },
    {
        label: '(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
        value: 210,
    },
    {
        label: '(GMT+02:00) Ljubljana',
        value: 211,
    },
    {
        label: '(GMT+02:00) Luxembourg',
        value: 212,
    },
    {
        label: '(GMT+02:00) Madrid',
        value: 213,
    },
    {
        label: '(GMT+02:00) Malta',
        value: 214,
    },
    {
        label: '(GMT+02:00) Monaco',
        value: 215,
    },
    {
        label: '(GMT+02:00) Minsk',
        value: 216,
    },
    {
        label: '(GMT+02:00) Oslo',
        value: 217,
    },
    {
        label: '(GMT+02:00) Prague',
        value: 218,
    },
    {
        label: '(GMT+02:00) Rome',
        value: 219,
    },
    {
        label: '(GMT+02:00) Sarajevo',
        value: 220,
    },
    {
        label: '(GMT+02:00) Skopje',
        value: 221,
    },
    {
        label: '(GMT+02:00) Stockholm',
        value: 222,
    },
    {
        label: '(GMT+02:00) Tirane',
        value: 223,
    },
    {
        label: '(GMT+02:00) Vaduz',
        value: 224,
    },
    {
        label: '(GMT+02:00) Vienna',
        value: 225,
    },
    {
        label: '(GMT+02:00) Zagreb',
        value: 226,
    },
    {
        label: '(GMT+02:00) Zurich',
        value: 227,
    },
    {
        label: '(GMT+03:00) Addis Ababa',
        value: 228,
    },
    {
        label: '(GMT+03:00) Asmara',
        value: 229,
    },
    {
        label: '(GMT+03:00) Dar es Salaam',
        value: 230,
    },
    {
        label: '(GMT+03:00) Djibouti',
        value: 231,
    },
    {
        label: '(GMT+03:00) Juba',
        value: 232,
    },
    {
        label: '(GMT+03:00) Kampala',
        value: 233,
    },
    {
        label: '(GMT+03:00) Mogadishu',
        value: 234,
    },
    {
        label: '(GMT+03:00) Nairobi',
        value: 235,
    },
    {
        label: '(GMT+03:00) Aden',
        value: 236,
    },
    {
        label: '(GMT+03:00) Bahrain',
        value: 237,
    },
    {
        label: '(GMT+03:00) Baghdad',
        value: 238,
    },
    {
        label: '(GMT+03:00) Famagusta',
        value: 239,
    },
    {
        label: '(GMT+03:00) Gaza',
        value: 240,
    },
    {
        label: '(GMT+03:00) Hebron',
        value: 241,
    },
    {
        label: '(GMT+03:00) Kuwait',
        value: 242,
    },
    {
        label: '(GMT+03:00) Nicosia',
        value: 243,
    },
    {
        label: '(GMT+03:00) Qatar',
        value: 244,
    },
    // {
    //     label: '(GMT+03:00) Tel Aviv',
    //     value: 245,
    // },
    {
        label: '(GMT+03:00) Kuwait, Riyadh',
        value: 246,
    },
    {
        label: '(GMT+03:00) Athens',
        value: 247,
    },
    {
        label: '(GMT+03:00) Bucharest',
        value: 248,
    },
    {
        label: '(GMT+03:00) Chisinau',
        value: 249,
    },
    {
        label: '(GMT+03:00) Helsinki',
        value: 250,
    },
    {
        label: '(GMT+03:00) Kirov',
        value: 251,
    },
    {
        label: '(GMT+03:00) Moscow, St. Petersburg, Volgograd',
        value: 252,
    },
    {
        label: '(GMT+03:00) Riga',
        value: 253,
    },
    {
        label: '(GMT+03:00) Simferopol',
        value: 254,
    },
    {
        label: '(GMT+03:00) Sofia',
        value: 255,
    },
    {
        label: '(GMT+03:00) Tallinn',
        value: 256,
    },
    // {
    //     label: '(GMT+03:00) Tiraspol',
    //     value: 257,
    // },
    {
        label: '(GMT+03:00) Uzhgorod',
        value: 258,
    },
    {
        label: '(GMT+03:00) Vilnius',
        value: 259,
    },
    {
        label: '(GMT+03:00) Volgograd',
        value: 260,
    },
    {
        label: '(GMT+03:00) Zaporozhye',
        value: 261,
    },
    {
        label: '(GMT+03:00) Antananarivo',
        value: 262,
    },
    {
        label: '(GMT+03:00) Comoro',
        value: 263,
    },
    {
        label: '(GMT+03:00) Mayotte',
        value: 264,
    },
    {
        label: '(GMT+03:30) Tehran',
        value: 265,
    },
    {
        label: '(GMT+04:00) Baku',
        value: 266,
    },
    {
        label: '(GMT+04:00) Muscat',
        value: 267,
    },
    {
        label: '(GMT+04:00) Abu Dhabi, Muscat',
        value: 268,
    },
    {
        label: '(GMT+04:00) Tbilisi',
        value: 269,
    },
    {
        label: '(GMT+04:00) Yerevan',
        value: 270,
    },
    {
        label: '(GMT+04:00) Astrakhan',
        value: 271,
    },
    {
        label: '(GMT+04:00) Samara',
        value: 272,
    },
    {
        label: '(GMT+04:00) Saratov',
        value: 273,
    },
    {
        label: '(GMT+04:00) Ulyanovsk',
        value: 274,
    },
    {
        label: '(GMT+04:00) Mahe',
        value: 275,
    },
    {
        label: '(GMT+04:00) Port Louis',
        value: 276,
    },
    {
        label: '(GMT+04:00) Reunion',
        value: 277,
    },
    {
        label: '(GMT+04:30) Kabul',
        value: 278,
    },
    {
        label: '(GMT+05:00) Mawson',
        value: 279,
    },
    {
        label: '(GMT+05:00) Aqtau',
        value: 280,
    },
    {
        label: '(GMT+05:00) Aqtobe',
        value: 281,
    },
    {
        label: '(GMT+05:00) Ashgabat',
        value: 282,
    },
    {
        label: '(GMT+05:00) Atyrau',
        value: 283,
    },
    {
        label: '(GMT+05:00) Dushanbe',
        value: 284,
    },
    {
        label: '(GMT+05:00) Oral',
        value: 285,
    },
    {
        label: '(GMT+05:00) Samarkand',
        value: 286,
    },
    {
        label: '(GMT+05:00) Islamabad, Karachi',
        value: 287,
    },
    {
        label: '(GMT+05:00) Tashkent',
        value: 288,
    },
    {
        label: '(GMT+05:00) Yekaterinburg',
        value: 289,
    },
    {
        label: '(GMT+05:00) Maldives',
        value: 290,
    },
    // {
    //     label: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    //     value: 291,
    // },
    {
        label: '(GMT+05:30) Sri Jayawardenepura',
        value: 292,
    },
    {
        label: '(GMT+05:30) Kolkata',
        value: 293,
    },
    {
        label: '(GMT+05:45) Kathmandu',
        value: 294,
    },
    {
        label: '(GMT+06:00) Astana',
        value: 295,
    },
    {
        label: '(GMT+06:00) Bishkek',
        value: 296,
    },
    // {
    //     label: '(GMT+06:00) Kashgar',
    //     value: 297,
    // },
    {
        label: '(GMT+06:00) Omsk',
        value: 298,
    },
    {
        label: '(GMT+06:00) Qyzylorda',
        value: 299,
    },
    {
        label: '(GMT+06:00) Thimphu',
        value: 300,
    },
    {
        label: '(GMT+06:00) Urumqi',
        value: 301,
    },
    {
        label: '(GMT+06:00) Dhaka',
        value: 302,
    },
    {
        label: '(GMT+06:00) Novosibirsk',
        value: 303,
    },
    {
        label: '(GMT+06:00) Chagos',
        value: 304,
    },
    {
        label: '(GMT+06:30) Yangon',
        value: 305,
    },
    // {
    //     label: '(GMT+06:30) Yangon (Rangoon)',
    //     value: 306,
    // },
    {
        label: '(GMT+06:30) Cocos',
        value: 307,
    },
    {
        label: '(GMT+07:00) Davis',
        value: 308,
    },
    {
        label: '(GMT+07:00) Barnaul',
        value: 309,
    },
    {
        label: '(GMT+07:00) Bangkok, Hanoi, Jakarta',
        value: 310,
    },
    {
        label: '(GMT+07:00) Ho Chi Minh',
        value: 311,
    },
    {
        label: '(GMT+07:00) Hovd',
        value: 312,
    },
    {
        label: '(GMT+07:00) Jakarta',
        value: 313,
    },
    {
        label: '(GMT+07:00) Novokuznetsk',
        value: 314,
    },
    {
        label: '(GMT+07:00) Phnom Penh',
        value: 315,
    },
    {
        label: '(GMT+07:00) Pontianak',
        value: 316,
    },
    {
        label: '(GMT+07:00) Tomsk',
        value: 317,
    },
    {
        label: '(GMT+07:00) Vientiane',
        value: 318,
    },
    {
        label: '(GMT+07:00) Krasnoyarsk',
        value: 319,
    },
    {
        label: '(GMT+07:00) Christmas',
        value: 320,
    },
    {
        label: '(GMT+08:00) Casey',
        value: 321,
    },
    {
        label: '(GMT+08:00) Brunei',
        value: 322,
    },
    {
        label: '(GMT+08:00) Choibalsan',
        value: 323,
    },
    // {
    //     label: '(GMT+08:00) Chongqing',
    //     value: 324,
    // },
    // {
    //     label: '(GMT+08:00) Harbin',
    //     value: 325,
    // },
    {
        label: '(GMT+08:00) Hong Kong',
        value: 326,
    },
    {
        label: '(GMT+08:00) Kuala Lumpur',
        value: 327,
    },
    {
        label: '(GMT+08:00) Kuching',
        value: 328,
    },
    {
        label: '(GMT+08:00) Macau',
        value: 329,
    },
    {
        label: '(GMT+08:00) Makassar',
        value: 330,
    },
    {
        label: '(GMT+08:00) Manila',
        value: 331,
    },
    {
        label: '(GMT+08:00) Irkutsk',
        value: 332,
    },
    {
        label: '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
        value: 333,
    },
    {
        label: '(GMT+08:00) Kuala Lumpur, Singapore',
        value: 334,
    },
    {
        label: '(GMT+08:00) Taipei',
        value: 335,
    },
    {
        label: '(GMT+08:00) Ulaanbaatar',
        value: 336,
    },
    {
        label: '(GMT+08:00) Perth',
        value: 337,
    },
    {
        label: '(GMT+08:30) Pyongyang',
        value: 338,
    },
    {
        label: '(GMT+08:30) Eucla',
        value: 339,
    },
    {
        label: '(GMT+09:00) Chita',
        value: 340,
    },
    {
        label: '(GMT+09:00) Dili',
        value: 341,
    },
    {
        label: '(GMT+09:00) Jayapura',
        value: 342,
    },
    {
        label: '(GMT+09:00) Khandyga',
        value: 343,
    },
    {
        label: '(GMT+09:00) Osaka, Sapporo, Tokyo',
        value: 344,
    },
    {
        label: '(GMT+09:00) Seoul',
        value: 345,
    },
    {
        label: '(GMT+09:00) Yakutsk',
        value: 346,
    },
    {
        label: '(GMT+09:00) Palau',
        value: 347,
    },
    {
        label: '(GMT+09:30) Adelaide',
        value: 348,
    },
    {
        label: '(GMT+09:30) Broken Hill',
        value: 349,
    },
    {
        label: '(GMT+09:30) Darwin',
        value: 350,
    },
    {
        label: '(GMT+10:00) Brisbane',
        value: 351,
    },
    {
        label: '(GMT+10:00) Vladivostok',
        value: 352,
    },
    {
        label: '(GMT+10:00) Hobart',
        value: 353,
    },
    {
        label: '(GMT+10:00) Lindeman',
        value: 354,
    },
    {
        label: '(GMT+10:00) Chuuk',
        value: 355,
    },
    // {
    //     label: '(GMT+10:00) Saipan',
    //     value: 356,
    // },
    {
        label: '(GMT+10:00) Guam, Port Moresby',
        value: 357,
    },
    // {
    //     label: '(GMT+10:30) Lord Howe Island',
    //     value: 358,
    // },
    {
        label: '(GMT+10:30) Lord Howe Island',
        value: 359,
    },
    {
        label: '(GMT+11:00) Sakhalin',
        value: 360,
    },
    {
        label: '(GMT+11:00) Srednekolymsk',
        value: 361,
    },
    {
        label: '(GMT+11:00) Magadan, Solomon Is., New Caledonia',
        value: 362,
    },
    {
        label: '(GMT+11:00) Currie',
        value: 363,
    },
    {
        label: '(GMT+11:00) Melbourne',
        value: 364,
    },
    {
        label: '(GMT+11:00) Sydney',
        value: 365,
    },
    {
        label: '(GMT+11:00) Efate',
        value: 366,
    },
    {
        label: '(GMT+11:00) Bougainville',
        value: 367,
    },
    {
        label: '(GMT+11:00) Guadalcanal',
        value: 368,
    },
    {
        label: '(GMT+11:00) Kosrae',
        value: 369,
    },
    {
        label: '(GMT+11:00) Norfolk',
        value: 370,
    },
    {
        label: '(GMT+11:00) Noumea',
        value: 371,
    },
    {
        label: '(GMT+11:00) Pohnpei',
        value: 372,
    },
    {
        label: '(GMT+12:00) Anadyr',
        value: 373,
    },
    {
        label: '(GMT+12:00) Petropavlovsk-Kamchatsky',
        value: 374,
    },
    // {
    //     label: '(GMT+12:00) Coordinated Universal Time+12',
    //     value: 375,
    // },
    {
        label: '(GMT+12:00) Funafuti',
        value: 376,
    },
    {
        label: '(GMT+12:00) Kwajalein',
        value: 377,
    },
    {
        label: '(GMT+12:00) Majuro',
        value: 378,
    },
    {
        label: '(GMT+12:00) Nauru',
        value: 379,
    },
    {
        label: '(GMT+12:00) Tarawa',
        value: 380,
    },
    {
        label: '(GMT+12:00) Wake',
        value: 381,
    },
    {
        label: '(GMT+12:00) Wallis',
        value: 382,
    },
    {
        label: '(GMT+12:00) Auckland, Wellington',
        value: 383,
    },
    // {
    //     label: '(GMT+12:00) Fiji',
    //     value: 384,
    // },
    {
        label: '(GMT+12:45) Chatham Islands',
        value: 385,
    },
    {
        label: '(GMT+13:00) Phoenix Islands, Tokelau, Tonga',
        value: 386,
    },
    {
        label: '(GMT+13:00) Fakaofo',
        value: 387,
    },
    {
        label: '(GMT+13:00) Tongatapu',
        value: 388,
    },
    {
        label: '(GMT+14:00) Apia',
        value: 389,
    },
    {
        label: '(GMT+14:00) Line Islands',
        value: 390,
    },
];

const currentDate: Date = new Date;
const monthsEn: Array<string> = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];
const monthsFr: Array<string> = ['Janv.', 'Fevr.', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil.', 'Aout', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];
const daysEn: Array<string> = ['Sun.', 'Mon.', 'Tues.', 'Wed.', 'Thurs.', 'Fri.', 'Sat.'];
const daysFr: Array<string> = ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'];
export const dateFormats = [
    {
        label: `DD/MM (${currentDate.getUTCDate() < 10 ? '0' : ''}${currentDate.getUTCDate()}/${currentDate.getMonth()+1 < 10 ? '0' : ''}${currentDate.getMonth()+1})`,
        value: 0,
    },
    {
        label: `MM/DD (${currentDate.getMonth()+1 < 10 ? '0' : ''}${currentDate.getMonth()+1}/${currentDate.getUTCDate() < 10 ? '0' : ''}${currentDate.getUTCDate()})`,
        value: 1,
    },
    {
        label: `DD Month (${currentDate.getUTCDate() < 10 ? '0' : ''}${currentDate.getUTCDate()} ${monthsEn[currentDate.getMonth()]})`,
        value: 2,
    },
    {
        label: `DD Mois (${currentDate.getUTCDate() < 10 ? '0' : ''}${currentDate.getUTCDate()} ${monthsFr[currentDate.getMonth()]})`,
        value: 3,
    },
    {
        label: `Day DD (${daysEn[currentDate.getDay()]} ${currentDate.getUTCDate() < 10 ? '0' : ''}${currentDate.getUTCDate()})`,
        value: 4,
    },
    {
        label: `Jour DD (${daysFr[currentDate.getDay()]} ${currentDate.getUTCDate() < 10 ? '0' : ''}${currentDate.getUTCDate()})`,
        value: 5,
    },
];

export const languages = [
    {
        label: 'English',
        value: 'en',
    },
    {
        label: 'Français',
        value: 'fr',
    }
];

export const sceneTypes: Array<string> = [
    'crypto',
    'text',
    'clock',
    'weather',
    'gif',
    'timer',
    'pomodoro',
    'off',
    'spotify',
    'countdown',
    'canvas',
    'stock',
    'twitch',
];

export const displayModes = {
    [ProductModelType.LEGACY]: {
        crypto: [0, 1, 2],
        text: [0],
        clock: [0],
        weather: [0, 1],
        spotify: [0, 1],
        countdown: [],
        canvas: [],
        stock: [],
        twitch: [],
    },
    [ProductModelType.STANDARD]: {
        crypto: [0, 1, 2, 3],
        text: [0],
        clock: [0, 1, 2],
        weather: [0],
        spotify: [0],
        countdown: [0, 1, 2, 3],
        canvas: [0],
        stock: [0, 1, 2, 3],
        twitch: [0, 1, 2],
    },
};
